import React, { useState } from "react";
import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AppPaths from "components/AppPaths";
import BurgerMenu from "components/BurgerMenu";
import "./AdminMenu.css";

const AdminMenu = () => {
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const [open, setOpen] = useState(true);

  const menuItems = [
    { path: AppPaths.ADMIN_DASHBOARD, label: "Panel" },
    { path: AppPaths.ADMIN_SING_DAYS, label: "Dwudziestki" },
    { path: AppPaths.ADMIN_USER_PRESENCE, label: "Nieobecności" },
    { path: AppPaths.SONG_LIST, label: "Aplikacja" },
  ];

  return (
    <>
      {!isPortrait && open && (
        <Drawer
          variant="permanent"
          open
          classes={{ paper: 'admin-menu' }}
        >
          <IconButton className="admin-menu-toggle" onClick={() => setOpen(false)}>
            <ChevronLeftIcon />
          </IconButton>
          <List>
            {menuItems.map((item) => (
              <ListItem button component={Link} to={item.path} key={item.path}>
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}
      {!isPortrait && !open && (
        <IconButton className="admin-menu-toggle-closed" onClick={() => setOpen(true)}>
          <ChevronRightIcon />
        </IconButton>
      )}
      <BurgerMenu menuItems={menuItems} />
    </>
  );
};

export default AdminMenu;
